import { LineChartDS } from "@qivia/ui/src/designSystem/components/Charts/LineChart";
import { useTranslation } from "react-i18next";
import { EmptyChart } from "./emptyChart";
import { TotalType } from "@qivia/ui/src/designSystem/components/Charts/CardChart";
import {
  dateFormatterDayShortMonthYear,
  dateFormatterMonthYear,
} from "@qivia/ui";
import "../../../../i18n/i18n";
import { GetCompanyBalancePerPeriodType } from "../../homeAPI";

export const BalanceChart = (props: {
  totalType: TotalType;
  data: GetCompanyBalancePerPeriodType;
}) => {
  const { t } = useTranslation();
  const balancePerPeriod = props.data;
  const dateFormatter =
    props.totalType === "month"
      ? dateFormatterDayShortMonthYear
      : dateFormatterMonthYear;

  const balanceData = balancePerPeriod
    ? balancePerPeriod[props.totalType].map((bpp) => ({
        value: bpp.amount / 100,
        date: dateFormatter(new Date(bpp.day)),
      }))
    : [];

  return (
    <>
      {!balanceData.length ? (
        <EmptyChart isBalanceChart={true} />
      ) : (
        <LineChartDS
          transactions={balanceData}
          legend={t("dashboard.charts.title.balancePerPeriod.legend")}
          unit={t("dashboard.charts.title.balancePerPeriod.unit")}
        />
      )}
    </>
  );
};
